import { Box } from '@components/Box'
import { NoData } from '@components/NoData'
import { Table } from '@components/Table'
import { SortingType } from '@components/Table/interface'
import { OrderByEnum } from '@interfaces/dashboard/CategoryParam'
import { CategoryProps } from './interface'

export function Category({
  data,
  isLoading,
  handleSortChange,
  handleWaypointEnter,
}: CategoryProps) {
  const items = data?.pages.flatMap(row => row?.data) || []
  return (
    <>
      <Box.Title>หมวดหมู่</Box.Title>
      <Table
        className='mb-[30px] max-h-[250px] pr-[10px]'
        bodyClassName='border-b border-gray text-[14px] font-light text-secondary hover:bg-blue-4/10'
        data={items}
        columns={[
          {
            column: 'ค้นหาจากหมวดหมู่',
            accessor: 'category',
            cell: ({ value }) => (
              <div className='line-clamp-1 break-word'>{value}</div>
            ),
            cellClassName: 'py-[10px] pr-[10px]',
            sortKey: OrderByEnum.CATEGORY_NAME,
            isSortable: true,
          },
          {
            column: 'จำนวนค้นหา',
            accessor: 'totalSearch',
            cell: ({ value }) => (
              <div>{(value as number).toLocaleString()}</div>
            ),
            cellClassName: 'py-[10px] pr-[10px] w-[180px]',
            sortKey: OrderByEnum.TOTAL_SEARCH,
            isSortable: true,
          },
        ]}
        initialSort={{
          key: OrderByEnum.TOTAL_SEARCH,
          order: SortingType.DESC,
        }}
        isLoading={isLoading}
        fixedHeader
        onSort={handleSortChange}
        onWaypointEnter={handleWaypointEnter}
      />
    </>
  )
}
